import { EventReportRequestParameters } from 'common/api/api.ts'
import { reportApi } from 'common/api/entitiesApi.tsx'
import { convertError, downloadCSVData } from 'common/util/Util.tsx'

type ReportExportFormat = 'csv' | 'xlsx'

const DEFAULT_FILE_NAMES: Record<ReportExportFormat, string> = {
  csv: 'report.csv',
  xlsx: 'report.xlsx',
}

const FALLBACK_EXPORT_ERROR = 'Failed to export report. Please try narrowing the filters.'

const parseFileName = (contentDisposition: string | null, format: ReportExportFormat) => {
  if (!contentDisposition) return DEFAULT_FILE_NAMES[format]

  const utf8Match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i)
  if (utf8Match?.[1]) {
    try {
      return decodeURIComponent(utf8Match[1].trim().replace(/"/g, ''))
    } catch {
      return utf8Match[1].trim().replace(/"/g, '')
    }
  }

  const plainMatch = contentDisposition.match(/filename=([^;]+)/i)
  if (plainMatch?.[1]) {
    return plainMatch[1].trim().replace(/^"|"$/g, '')
  }

  return DEFAULT_FILE_NAMES[format]
}

export const downloadReport = async (format: ReportExportFormat, payload: EventReportRequestParameters) => {
  try {
    const response =
      format === 'xlsx' ? await reportApi.reportExportXlsx(payload) : await reportApi.reportExportCsv(payload)

    const blob = await response.blob()
    const fileName = parseFileName(response.headers.get('Content-Disposition'), format)
    downloadCSVData(fileName, blob)
  } catch (error: any) {
    const parsedMessage = await convertError(error)
    throw new Error(parsedMessage || FALLBACK_EXPORT_ERROR)
  }
}
